<template>
  <MessageBox :class="$style.messageBox" :title="$t('auth.label.signing')" :icon="'generic/info'">
    <p class="mb-4">{{ $t("auth.label.takeMoment") }}</p>
  </MessageBox>
</template>

<script lang="ts" setup>
import { useOidcStore } from "@scayla/core";
import { computed, onMounted, unref } from "vue";
import { useRouter } from "vue-router";

import MessageBox from "@/components/MessageBox.vue";
import { Routes } from "@/router";

const { state, actions } = useOidcStore();

const userManager = computed(() => state.value.userManager);

const router = useRouter();

onMounted(async () => {
  let user = (await unref(state).userManager?.getUser()) ?? unref(state).user;
  user ??= (await userManager.value?.signinRedirectCallback()) ?? null;
  if (user) {
    actions.value.setUser(user);
  }
  await router.push(Routes.HOME);
});
</script>

<style module lang="scss">
.messageBox {
  width: 100dvw;
  background-color: white;
  text-align: center;
  height: 100dvh;
  justify-content: space-between;
  max-width: unset;
}
</style>
